import get from "lodash.get";
import { REHYDRATE } from "redux-persist";
import LiveActionTypes from "./types";
import ContractActionTypes from "services/contract/types";
import AuthenticationActionTypes from "services/authentication/types";

const initialState = {
  filters: {
    areaType: ["prm", "normal", "pedestrian"],
    timestamp: Math.round(new Date().getTime() / 1000), // today in seconds
  },
  map: {
    initialized: false,
  },
  availableParking: { initialized: false },
  parkedCars: { initialized: false },
  flowDetails: { initialized: false },
  flowGeneral: { initialized: false },
  parkDetails: { initialized: false },
  pedestrianDetails: { initialized: false },
  autoRefresh: false,
  initialized: false,
  alertEvents: {
    filters: {
      output_types: ["BO_TOAST"],
    },
    pagination: {
      page: 1,
      limit: 100,
    },
  },
  alertModalPosition: { x: 0, y: 0 },
};

const LiveReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...initialState,
        alertModalPosition: {
          ...get(action, "payload.Live.alertModalPosition"),
        },
        map: {
          ...get(initialState, "map"),
          ...(get(action, "payload.Live.map.selectedLayers") && {
            selectedLayers: [...get(action, "payload.Live.map.selectedLayers")],
          }),
        },
      };
    case AuthenticationActionTypes.LOG_OUT:
    case ContractActionTypes.SWITCH_CONTRACT:
      return initialState;
    case LiveActionTypes.SET_LOADING:
      return {
        ...state,
        [action.statName]: {
          ...state[action.statName],
          initialized: false,
        },
      };
    case LiveActionTypes.SET_AUTO_REFRESH:
      return {
        ...state,
        autoRefresh: action.autoRefresh,
      };
    case LiveActionTypes.SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.key]: action.value,
        },
      };
    case LiveActionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.value,
      };
    case LiveActionTypes.SET_MAP_INFOS:
      return {
        ...state,
        map: {
          ...action.map,
          initialized: true,
        },
      };
    case LiveActionTypes.SET_PARKED_CARS_LIST:
      return {
        ...state,
        parkedCars: {
          ...state.parkedCars,
          initialized: true,
          selectedIndex: null,
          hoverIndex: null,
          page: 0,
          items: action?.value?.items || [],
          length: action?.value?.items?.length || 0,
          others: action?.value?.others || null,
        },
      };
    case LiveActionTypes.SET_AVAILABLE_PARKING_LIST:
      return {
        ...state,
        availableParking: {
          ...state.availableParking,
          initialized: true,
          selectedIndex: null,
          hoverIndex: null,
          page: 0,
          items: action?.value?.items || [],
          length: action?.value?.items?.length || 0,
          others: action?.value?.others || null,
        },
      };
    case LiveActionTypes.SET_SELECTED_LAYERS:
      return {
        ...state,
        map: {
          ...state.map,
          selectedLayers: action.layers,
        },
      };
    case LiveActionTypes.SET_FLOW_DETAILS_STATS:
      return {
        ...state,
        flowDetails: {
          ...action.stats,
          data: action?.stats?.data,
          initialized: true,
        },
      };
    case LiveActionTypes.SET_FLOW_GENERAL_STATS:
      return {
        ...state,
        flowGeneral: {
          ...action.stats,
          data: action?.stats?.data,
          initialized: true,
        },
      };
    case LiveActionTypes.SET_PARK_DETAILS_STATS:
      return {
        ...state,
        parkDetails: {
          ...action.stats,
          data: action?.stats?.data,
          initialized: true,
        },
      };
    case LiveActionTypes.SET_PEDESTRIAN_DETAILS_STATS:
      return {
        ...state,
        pedestrianDetails: {
          ...action.stats,
          data: action?.stats?.data,
          initialized: true,
        },
      };
    case LiveActionTypes.SET_INITIALIZED:
      return {
        ...state,
        initialized: action.value,
      };
    case LiveActionTypes.SET_ALERT_EVENTS:
      return {
        ...state,
        alertEvents: {
          ...state.alertEvents,
          data: action.data,
        },
      };
    case LiveActionTypes.SET_ALERT_MODAL_POSITION:
      return {
        ...state,
        alertModalPosition: action.position,
      };
    default:
      return state;
  }
};

export default LiveReducer;
